import { Button } from '@chakra-ui/react';

import { usePagination } from '../../hooks/usePagination';
import { paginationItems } from '../../utils/components/paginate';

export type PaginationProps = {
  currentPage: number;
  lastPage: number;
  maxLength: number;
  fnc?: any;
  setCurrentPage: (page: number) => void;
};

export const Pagination = ({
  currentPage,
  lastPage,
  maxLength,
  fnc,
  setCurrentPage
}: PaginationProps) => {
  const pageNums = paginationItems(currentPage, lastPage, maxLength);

  const prevPage = () => {
    setCurrentPage(currentPage - 1);
    fnc({ page: currentPage - 1 });
  };

  const changePage = (page: number) => {
    setCurrentPage(page);
    fnc({ page: page });
  };

  const nextPage = () => {
    setCurrentPage(currentPage + 1);
    fnc({ page: currentPage + 1 });
  };

  return (
    <>
      <Button
        disabled={currentPage === 1}
        variant="ghost"
        _active={{}}
        _focus={{
          '&:focus': {
            boxShadow: 'none !important'
          }
        }}
        onClick={prevPage}
      >
        {'<'}
      </Button>
      {pageNums.map((pageNum, idx) => (
        <Button
          fontSize={{ base: '.65rem', md: 'inherit' }}
          key={idx}
          bg={currentPage === pageNum ? '#146CFA' : 'transparent'}
          color={currentPage === pageNum ? '#fff' : '#323232'}
          variant="ghost"
          disabled={isNaN(pageNum)}
          _hover={{
            opacity: '.8'
          }}
          _active={{}}
          _focus={{
            '&:focus': {
              boxShadow: 'none !important'
            }
          }}
          onClick={() => {
            changePage(pageNum);
          }}
        >
          {!isNaN(pageNum) ? pageNum : '...'}
        </Button>
      ))}
      <Button
        disabled={currentPage === lastPage}
        variant="ghost"
        _active={{}}
        _focus={{
          '&:focus': {
            boxShadow: 'none !important'
          }
        }}
        onClick={nextPage}
      >
        {'>'}
      </Button>
    </>
  );
};
